
  @if(!isMobile){
    <div class="the_container">
    <div class="update-text">Names to update</div>

    <div class="d-flex align-items-center dp-chip-gap">
      <div
        class="dp-chip"
        [ngClass]="{ selected: selectedChip === 'all' }"
        (click)="selectChip('all')"
      >
        All names
      </div>
      <div
        class="dp-chip"
        [ngClass]="{ selected: selectedChip === 'assigned' }"
        (click)="selectChip('assigned')"
      >
        Assigned
      </div>
      <div
        class="dp-chip"
        [ngClass]="{ selected: selectedChip === 'notAssigned' }"
        (click)="selectChip('notAssigned')"
      >
        Not Assigned
      </div>
    </div>

    <div class="manage-user-button-group">
      <button class="filter-button">
        <h1 class="filter-button-text">Filter</h1>
        <img src="assets/filter.svg" />
      </button>
      <div class="separatorDiv"></div>
  
      <!-- @if(toggleFilter){ -->
      <div class="d-flex filter-options slide-in">
        <div class="custom-dropdown">
          <mat-form-field class="select-mat-form-field custom-select-form">
            <mat-select class="custom-mat-select custom-select" id="state" (selectionChange)="onStateChange()"
              [(ngModel)]="selectedState" placeholder="Select State">
              <mat-option *ngFor="let state of states" [value]="state">
                {{ state }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="custom-dropdown">
  
          <mat-form-field class="select-mat-form-field custom-select-form">
            <mat-select class="custom-mat-select" id="district" (selectionChange)="onDistrictChange()"
              [(ngModel)]="selectedDistrict" placeholder="Select District">
              <mat-option *ngFor="let district of districts[selectedState]" [value]="district">
                {{ district }}
              </mat-option>
            </mat-select>
            <button mat-icon-button *ngIf="selectedDistrict != ''" matSuffix (click)="clearDistrictSelection()"
              class="clear-button">
              <mat-icon class="clear-icon">clear</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
  
      <!-- } -->
      </div>



    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center input-field-gap">
        <input
          class="dp-input-control input-field-control"
          placeholder="Search by name"
          [(ngModel)]="memberName"
          (ngModelChange)="onSearchMemberName($event)"
        />
        <input
          class="dp-input-control input-field-control"
          placeholder="Search by address"
          [(ngModel)]="address"
          (ngModelChange)="onSearchAddressName($event)"
        />
        <input
          class="dp-input-control input-field-control"
          placeholder="Search by PIN"
          [(ngModel)]="pincode"
          (ngModelChange)="onSearchPincode($event)"
        />
      </div>
      <!-- <button class="dp-secondary-btn sort-btn">
        <span class="me-2">Sort by</span>
        <img src="../../assets/images/down-arrow.svg" />
      </button> -->
    </div>
  
    <div
      class="w-100 dp-table-scroll"
      infiniteScroll
      [scrollWindow]="false"
      [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="1000"
      (scrolled)="fetchPhilRecords(false)"
    >
      <table class="dp-table">
        <thead class="dp-table-header">
          <tr>
            <th class="sl-no-width">Serial Number</th>
            <th>Family Code</th>
            <th>Dikshyarthi Name</th>
            <th>Ritwick Name</th>
            <th>Contact</th>
            <th class="addr-width">Address</th>
            <th class="assign-width">Assigned to</th>
          </tr>
        </thead>
        <tbody class="dp-table-body">
          @for (row of namesToUpdateRecords; track row) { @if(isLoader) {
          <tr>
            <td [attr.colspan]="7">
              <dp-loader></dp-loader>
            </td>
          </tr>
          } @else {
          <tr
            [ngClass]="{ expanded: row.isExpanded }"
            (mouseover)="onRowMouseOver(row)"
            (mouseout)="onRowMouseOut(row)"
            (click)="onRowClick(row)"
            matTooltip="Click to expand"
            matTooltipPosition="below"
          >
            <td>
              <div class="serial-no">
                <span class="serial-no-text">{{ row.serialNo || "-" }}</span>
              </div>
            </td>
            <td class="fc-text" >
              <span (click)="openAreYouUpdatedDialog($event,row.fc)">{{ row.fc }}</span>
            </td>
            <td>{{ row.mNm }}</td>
            <td>{{ row.rNm || "-" }}</td>
            <td>{{ row.contact || "-" }}</td>
            <td class="addr-width">{{ row.addr || "-" }}</td>
            <td class="assign-width">{{ row.assignedFwId || "-" }}</td>
            <!-- <td class="expand-text">Expand</td> -->
          </tr>
          } @if(row.isExpanded) {
          <tr class="expanded-row hover-container">
            <td [attr.colspan]="7">
              <div class="d-flex flex-column hover-container-gap">
                <div class="row">
                  <div class="col-3">
                    <div class="d-flex flex-column">
                      <span class="header-text">Serial no.</span>
                      <span class="table-data-text">{{
                        row.serialNo || "-"
                      }}</span>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="d-flex flex-column">
                      <span class="header-text">Full name</span>
                      <span class="table-data-text">{{ row.mNm || "-" }}</span>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="d-flex flex-column">
                      <span class="header-text">Contact details</span>
                      <span class="table-data-text">{{
                        row.contact || "-"
                      }}</span>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="d-flex flex-column">
                      <span class="header-text">Ritwik’s name</span>
                      <span class="table-data-text">{{ row.rNm || "-" }}</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    <div class="d-flex flex-column">
                      <span class="header-text">Family code</span>
                      <span class="fc-text" (click)="openAreYouUpdatedDialog($event,row.fc)">{{ row.fc || "-" }}</span>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="d-flex flex-column">
                      <span class="header-text">Assigned to</span>
                      <span class="table-data-text">{{
                        row.assignedFwId || "-"
                      }}</span>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="d-flex flex-column">
                      <span class="header-text">Address</span>
                      <span class="table-data-text">{{ row.addr || "-" }}</span>
                    </div>
                  </div>
                </div>
                @if(!queryParamsObj['assigned']){
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex btn-gap">
                    <button
                      class="dp-secondary-btn hover-btn"
                      (click)="openEditDetailsDialog(row)"
                    >
                      <img src="../../assets/images/edit.svg" />
                      <span class="ms-1">Edit</span>
                    </button>
                    <button
                      class="dp-secondary-btn hover-btn"
                      (click)="openMasterSearchDialog(row.id, row.mNm, row.rNm , row.addr)"
                    >
                      <img src="../../assets/images/search.svg" />
                      <span class="ms-1">Search</span>
                    </button>
                    <!-- <button
                    *ngIf="!row.serialNo"
                      class="dp-secondary-btn hover-btn"
                      (click)="openDpnf(row)"
                    >
                      <span>DPNF</span>
                    </button> -->
                    <button
                      *ngIf="row.assignedFwId == null"
                      [ngClass]="{'dp-primary-btn hover-btn btn-pointer': row.assignEnabled,
                       'dp-primary-btn-disabled hover-btn btn-pointer':!row.assignEnambled }"
                      (click)="openFWAssignDialog(row.id)"
                      [disabled]="!row.assignEnabled"
                    >
                      <span>Assign to FW</span>
                    </button>
                  </div>
                  <div
                    class="collapse-container"
                    (click)="collapseRow($event, row)"
                    matTooltip="Click to collapse"
                    matTooltipPosition="above"
                  >
                    <img src="../../assets/images/collapse.svg" />
                  </div>
                </div>
                }
              </div>
            </td>
          </tr>
          } }
        </tbody>
      </table>
    </div>
  </div>
  }@else {
  <!-- mobile view  -->
  <div
    class="d-flex flex-column names-to-update-container-mobile flex-column justify-content-center"
    style="overflow-y: scroll"
  >
    <div class="search-container">
      <input
        class="search-input-mobile dp-input-control"
        type="text"
        [(ngModel)]="memberName"
        (ngModelChange)="onSearchMemberName($event)"
        placeholder="Search by member name"
        aria-label="Search"
      />
      <span class="search-icon">
        <img src="../../assets/images/search-dark.svg" />
      </span>
    </div>
  
    <div class="search-container">
      <input
        class="search-input-mobile dp-input-control"
        type="text"
        [(ngModel)]="address"
        (ngModelChange)="onSearchAddressName($event)"
        placeholder="Search by address"
        aria-label="Search1"
      />
      <span class="search-icon">
        <img src="../../assets/images/search-dark.svg" />
      </span>
    </div>
    <div class="search-container">
      <input
        class="search-input-mobile dp-input-control"
        type="text"
        [(ngModel)]="pincode"
        (ngModelChange)="onSearchPincode($event)"
        placeholder="Search by Pincode"
        aria-label="Search"
      />
      <span class="search-icon">
        <img src="../../assets/images/search-dark.svg" />
      </span>
    </div>
  
    
  
    <div class="mobile-container mt-1">
      <div
        class="dp-chip-mobile"
        [ngClass]="{ selected: selectedChip === 'all' }"
        (click)="selectChip('all')"
      >
        All names
      </div>
      <div
        class="dp-chip-mobile"
        [ngClass]="{ selected: selectedChip === 'assigned' }"
        (click)="selectChip('assigned')"
      >
        Assigned
      </div>
      <div
        class="dp-chip-mobile"
        [ngClass]="{ selected: selectedChip === 'notAssigned' }"
        (click)="selectChip('notAssigned')"
      >
        Not Assigned
      </div>
    </div>
    
    <div class="manage-user-button-group">
      <button class="filter-button">
        <h1 class="filter-button-text">Filter</h1>
        <img src="assets/filter.svg" />
      </button>
      <div class="separatorDiv"></div>
  
      <!-- @if(toggleFilter){ -->
      <div class="d-flex filter-options">
        <div class="custom-dropdown">
          <mat-form-field class="select-mat-form-field custom-select-form">
            <mat-select class="custom-mat-select custom-select" id="state" (selectionChange)="onStateChange()"
              [(ngModel)]="selectedState" placeholder="Select State">
              <mat-option *ngFor="let state of states" [value]="state">
                {{ state }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="custom-dropdown">
          <!-- <select id="stateSelect" class="dropdown-select">
                <option value="" disabled selected>District</option>
                <option value="state1">State 1</option>
                <option value="state2">State 2</option>
                <option value="state3">State 3</option>
              </select> -->
  
          <mat-form-field class="select-mat-form-field custom-select-form">
            <mat-select class="custom-mat-select" id="district" (selectionChange)="onDistrictChange()"
              [(ngModel)]="selectedDistrict" placeholder="Select District">
              <mat-option *ngFor="let district of districts[selectedState]" [value]="district">
                {{ district }}
              </mat-option>
            </mat-select>
            <button mat-icon-button *ngIf="selectedDistrict != ''" matSuffix (click)="clearDistrictSelection()"
              class="clear-button">
              <mat-icon class="clear-icon">clear</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
  
      <!-- } -->
      </div>
  
    <div
      class="d-flex flex-column justify-content-center"
      infiniteScroll
      [scrollWindow]="false"
      [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="1000"
      (scrolled)="fetchPhilRecords(false)"
    >
    <div style="height:300px; gap:10px;" class ="d-flex flex-column">
      @for (row of namesToUpdateRecords; track row) { @if(isLoader) {
        <div class="mobile-view-data-container">
          <dp-loader></dp-loader>
        </div>
        }@else {
        <div class="mobile-view-data-container">
          <div class="d-flex justify-content-between">
            <span class="header-text">Full name</span>
            <span class="data-text">{{ row.mNm || "-" }}</span>
          </div>
    
          <div class="d-flex justify-content-between">
            <span class="header-text">SL. no</span>
            <div class="serial-no">
              <span class="serial-no-text">{{ row.serialNo || "-" }}</span>
            </div>
          </div>
    
          <div class="d-flex justify-content-between">
            <span class="header-text">Family code</span>
            <span class="fc-text" (click)="openBottomSheetfc(row.fc, $event)">{{
              row.fc || "-"
            }}</span>
          </div>
          <div class="d-flex justify-content-between">
            <span class="header-text">Ritwik name</span>
            <span class="data-text">{{ row.rNm || "-" }}</span>
          </div>
    
          <div class="d-flex justify-content-between">
            <span class="header-text w-25">Permanent Address</span>
            <span class="data-text">{{ row.addr || "-" }}</span>
          </div>
    
          <div class="d-flex justify-content-between">
            <span class="header-text">Contact</span>
            <span class="data-text">{{ row.contact || "-" }}</span>
          </div>
    
          <div class="d-flex justify-content-between">
            <span class="header-text">Assign to</span>
            <span class="data-text">{{ row.assignedFwId || "-" }}</span>
          </div>
    
          @if(!queryParamsObj['assigned']){
            <div class="d-flex">
              <div class="d-flex justify-content-center align-items-center gap-10">
                <div class="d-flex btn-ga button-container">
                  <button
                    class="dp-secondary-btn hover-btn-mobile"
                    (click)="openEditDetailsDialogMobile(row)"
                  >
                    <img src="../../assets/images/edit.svg" />
                  </button>
                  <button
                    class="dp-secondary-btn hover-btn-mobile"
                    (click)="openMasterSearchDialogMobile(row.id, row.mNm, row.rNm , row.add)"
                  >
                    <img src="../../assets/images/search.svg" />
                  </button>
                  <!-- <button
                    *ngIf="!row.serialNo"
                    class="dp-secondary-btn hover-btn-mobile"
                    (click)="openDpnf(row)"
                  >
                    <span>DPNF</span>
                  </button> -->
                  <button
                    *ngIf="row.assignedFwId == null"
                    [ngClass]="{'dp-primary-btn hover-btn btn-pointer': row.assignEnabled,
                             'dp-primary-btn-disabled hover-btn btn-pointer':!row.assignEnambled }"
                    (click)="openFWAssignDialog(row.id)"
                    [disabled]="!row.assignEnabled"
                  >
                    <span>Assign</span>
                  </button>
                </div>
              </div>
            </div>
          
    
          }
        </div>
        } }
    </div>
      
    </div>
  </div>
  }

<app-loader [isLoading]="isLoading"></app-loader>
